import { Layout } from 'antd';
import styled from 'styled-components';
export const AppLayout = styled(Layout)`
  min-height: 100vh;
`;
